export default {
  en: {
    'tt-act-labor-guide-hours-diff': 'Act Labor Guide Hours +/-',
    'tt-adj-proj-diff-hours-comp-pct': 'Adj Proj +/- Hours Comp %',
    'tt-adj-theoretical-food-cost-pct-diff': 'Adj Theoretical Food Cost % +/-',
    'tt-all-net-sales-diff-pct': 'All Net Sales +/- %',
    'tt-all-net-sls': 'All Net Sls',
    'tt-avg-check-diff': 'Avg Check +/-',
    'tt-avg-hourly-rate-diff': 'Avg Hourly Rate +/-',
    'tt-canceled-item-amt-comp': 'Canceled Item Amt Comp',
    'tt-canceled-item-cnt-comp-pct': 'Canceled Item Cnt Comp %',
    'tt-canceled-order-amt-comp-pct': 'Canceled Order Amt Comp %',
    'tt-canceled-order-cnt-comp-pct': 'Canceled Order Cnt Comp %',
    'tt-cogs': 'COGS',
    'tt-cogs-diff': 'COGS +/-',
    'tt-cogs-food': 'COGS Food',
    'tt-cogs-food-diff': 'COGS Food +/-',
    'tt-cogs-other': 'COGS Other',
    'tt-cogs-other-diff': 'COGS Other +/-',
    'tt-cogs-paper': 'COGS Paper',
    'tt-cogs-paper-diff': 'COGS Paper +/-',
    'tt-delivery-avg-check-comp-pct': 'Delivery Avg Check Comp %',
    'tt-delivery-net-sales-comp-pct': 'Delivery Net Sales Comp %',
    'tt-delivery-refund-sales-comp-pct': 'Delivery Refund Sales Comp %',
    'tt-delivery-refund-trans-comp-diff': 'Delivery Refund Trans Comp +/-',
    'tt-delivery-trans-comp-diff': 'Delivery Trans Comp +/-',
    'tt-drive-thru-avg-check-comp-pct': 'Drive Thru Avg Check Comp %',
    'tt-drive-thru-net-sales-comp-pct': 'Drive Thru Net Sales Comp %',
    'tt-drive-thru-refund-sales-comp-pct': 'Drive Thru Refund Sales Comp %',
    'tt-drive-thru-refund-trans-comp-diff': 'Drive Thru Refund Trans Comp +/-',
    'tt-drive-thru-trans-comp-pct': 'Drive Thru Trans Comp %',
    'tt-dt-avg-check': 'DT Avg Check',
    'tt-dt-avg-check-diff': 'DT Avg Check +/-',
    'tt-dt-sales-diff-pct': 'DT Sales +/- %',
    'tt-dt-tcs-diff-pct': "DT TC's +/- %",
    'tt-eat-in-avg-check-comp-pct': 'Eat In Avg Check Comp %',
    'tt-eat-in-net-sales-comp-pct': 'Eat In Net Sales Comp %',
    'tt-eat-in-refund-sales-comp-pct': 'Eat In Refund Sales Comp %',
    'tt-eat-in-refund-trans-comp-diff': 'Eat In Refund Trans Comp +/-',
    'tt-eat-in-trans-comp-diff': 'Eat In Trans Comp +/-',
    'tt-food-pct-actual-vs-budget': 'Food % Actual Vs Budget',
    'tt-food-actual-vs-budget': 'Food Actual Vs Budget',
    'tt-food-cost-diff': 'Food Cost +/-',
    'tt-food-var-diff': 'Food Var +/-',
    'tt-food-var-cost-diff': 'Food Var Cost +/-',
    'tt-gap-variance-pct-diff': 'Gap Variance % +/-',
    'tt-hourly-labor-pct-diff': 'Hourly Labor % +/-',
    'tt-hourly-labor-diff-pct': 'Hourly Labor +/- %',
    'tt-hourly-labor-hours-diff-pct': 'Hourly Labor Hours +/- %',
    'tt-kiosk-avg-check-comp-pct': 'Kiosk Avg Check Comp %',
    'tt-kiosk-net-sales-comp-pct': 'Kiosk Net Sales Comp %',
    'tt-kiosk-refund-sales-comp-pct': 'Kiosk Refund Sales Comp %',
    'tt-kiosk-refund-trans-comp-diff': 'Kiosk Refund Trans Comp +/-',
    'tt-kiosk-trans-comp-diff': 'Kiosk Trans Comp +/-',
    'tt-lobby-avg-check': 'Lobby Avg Check',
    'tt-lobby-avg-check-diff': 'Lobby Avg Check +/-',
    'tt-lobby-sales-diff-pct': 'Lobby Sales +/- %',
    'tt-lobby-tcs-diff-pct': "Lobby TC's +/- %",
    'tt-management-labor-diff': 'Management Labor +/-',
    'tt-manager-void-amt-diff': 'Manager Void Amt +/-',
    'tt-manager-void-cnt-comp': 'Manager Void Cnt Comp',
    'tt-mgmt-labor-pct': 'Mgmt Labor %',
    'tt-mobile-delivery-avg-check-comp-pct': 'Mobile Delivery Avg Check Comp %',
    'tt-mobile-delivery-net-sales-comp-pct': 'Mobile Delivery Net Sales Comp %',
    'tt-mobile-delivery-refund-sales-comp-pct': 'Mobile Delivery Refund Sales Comp %',
    'tt-mobile-drive-thru-refund-trans-comp-diff': 'Mobile Drive Thru Refund Trans Comp +/-',
    'tt-mobile-drive-thru-trans-comp-diff': 'Mobile Drive Thru Trans Comp +/-',
    'tt-mobile-take-out-avg-check-comp-pct': 'Mobile Take Out Avg Check Comp %',
    'tt-mobile-take-out-net-sales-comp-pct': 'Mobile Take Out Net Sales Comp %',
    'tt-mobile-take-out-refund-sales-comp-pct': 'Mobile Take Out Refund Sales Comp %',
    'tt-mobile-take-out-refund-trans-comp-diff': 'Mobile Take Out Refund Trans Comp +/-',
    'tt-mobile-take-out-trans-comp-diff': 'Mobile Take Out Trans Comp +/-',
    'tt-net-sales-actual-vs-budget': 'Net Sales Actual Vs Budget',
    'tt-net-sales-comp-pct': 'Net Sales Comp %',
    'tt-other-cost-diff': 'Other Cost +/-',
    'tt-other-var-diff': 'Other Var +/-',
    'tt-other-var-cost-diff': 'Other Var Cost +/-',
    'tt-overring-amt-comp-diff': 'Overring Amt Comp +/-',
    'tt-paper-cost-diff': 'Paper Cost +/-',
    'tt-paper-var-diff': 'Paper Var +/-',
    'tt-paper-var-cost-diff': 'Paper Var Cost +/-',
    'tt-proj-labor-guide-hours': 'Proj Labor Guide Hours',
    'tt-proj-labor-guide-hours-diff': 'Proj Labor Guide Hours +/-',
    'tt-refund-sales-comp-pct': 'Refund Sales Comp %',
    'tt-refund-trans': 'Refund Trans',
    'tt-refund-trans-comp-diff': 'Refund Trans Comp +/-',
    'tt-salaried-labor-diff-pct': 'Salaried Labor +/- %',
    'tt-take-out-avg-check-comp-pct': 'Take Out Avg Check Comp %',
    'tt-take-out-net-sales-comp-pct': 'Take Out Net Sales Comp %',
    'tt-take-out-refund-sales-comp-pct': 'Take Out Refund Sales Comp %',
    'tt-take-out-refund-trans-comp-diff': 'Take Out Refund Trans Comp +/-',
    'tt-take-out-trans-comp-diff': 'Take Out Trans Comp +/-',
    'tt-tc-diff-pct': 'TC +/- %',
    'tt-theoretical-food-cost-pct-diff': 'Theoretical Food Cost % +/-',
    'tt-total-cost-diff': 'Total Cost +/-',
    'tt-total-labor-diff': 'Total Labor +/-',
    'tt-total-labor-pct-actual-vs-budget': 'Total Labor % Actual Vs Budget',
    'tt-total-labor-actual-vs-budget': 'Total Labor Actual Vs Budget',
    'tt-total-labor-cost': 'Total Labor Cost',
    'tt-total-labor-cost-diff': 'Total Labor Cost +/-',
    'tt-total-var-diff': 'Total Var +/-',
    'tt-total-var-cost-diff': 'Total Var Cost +/-',
    'tt-total-waste-diff': 'Total Waste +/-',
    'tt-total-waste-cost-diff': 'Total Waste Cost +/-',
    'tt-training-hours-diff': 'Training Hours +/-',
    'tt-transactions-comp-pct': 'Transactions Comp %',
    'tt-trans-comp-pct': 'Trans Comp %',
    'tt-trans-per-labor-hour-diff': 'Trans / Labor Hour +/-',
    // Shift Runner Scorecard info tooltip
    'tt-sms-shifts-explained':
      'counts dayparts worked as the scheduled floor leader (FL), not clock-in to clock-out shifts. A business day has {count} dayparts and one work shift can span several, so this is usually higher than the number of times the runner clocked in.',
    'tt-sms-overall-score': 'Overall Score',
    'tt-sms-overall-score-explained':
      'is comprised of 50% Forms Completion Score and 50% Operations Metrics Score.',
    'tt-sms-forms-completion-score': 'Forms Completion Score',
    'tt-sms-forms-completion-score-explained':
      'is equally weighted between Preshift Checklists and Travel Paths.',
    'tt-sms-operations-metrics-score': 'Operations Metrics Score',
    'tt-sms-operations-metrics-score-explained':
      'is equally weighted across 4 Operations Metrics:',
    'tt-sms-above-pct-is': 'For all areas, {pct}% or above is',
    'tt-sms-green': 'green',
    'tt-sms-and-below-pct-is': 'and below {pct}% is',
    'tt-sms-red': 'red',
  },
  es: {
    'tt-act-labor-guide-hours-diff': 'Horas Guía de Labor Actual +/-',
    'tt-adj-proj-diff-hours-comp-pct': 'Horas Proy Ajust +/- Comp %',
    'tt-adj-theoretical-food-cost-pct-diff': 'Costo Teórico de Alimentos Ajust % +/-',
    'tt-all-net-sales-diff-pct': 'Todas las Ventas Netas +/- %',
    'tt-all-net-sls': 'Todas las Ventas Netas',
    'tt-avg-check-diff': 'Cheque Promedio +/-',
    'tt-avg-hourly-rate-diff': 'Tarifa Promedio Por Hora +/-',
    'tt-canceled-item-amt-comp': 'Monto de Artículo Cancelado Comp',
    'tt-canceled-item-cnt-comp-pct': 'Cnt de Artículo Cancelado Comp %',
    'tt-canceled-order-amt-comp-pct': 'Monto de Orden Cancelada Comp %',
    'tt-canceled-order-cnt-comp-pct': 'Cnt de Orden Cancelada Comp %',
    'tt-cogs': 'COGS',
    'tt-cogs-diff': 'COGS +/-',
    'tt-cogs-food': 'COGS Alimentos',
    'tt-cogs-food-diff': 'COGS Alimentos +/-',
    'tt-cogs-other': 'COGS Otros',
    'tt-cogs-other-diff': 'COGS Otros +/-',
    'tt-cogs-paper': 'COGS Papel',
    'tt-cogs-paper-diff': 'COGS Papel +/-',
    'tt-delivery-avg-check-comp-pct': 'Cheque Promedio de Entrega Comp %',
    'tt-delivery-net-sales-comp-pct': 'Ventas Netas de Entrega Comp %',
    'tt-delivery-refund-sales-comp-pct': 'Ventas de Reembolso de Entrega Comp %',
    'tt-delivery-refund-trans-comp-diff': 'Trans de Reembolso de Entrega Comp +/-',
    'tt-delivery-trans-comp-diff': 'Trans de Entrega Comp +/-',
    'tt-drive-thru-avg-check-comp-pct': 'Cheque Promedio de Autoservicio Comp %',
    'tt-drive-thru-net-sales-comp-pct': 'Ventas Netas de Autoservicio Comp %',
    'tt-drive-thru-refund-sales-comp-pct': 'Ventas de Reembolso de Autoservicio Comp %',
    'tt-drive-thru-refund-trans-comp-diff': 'Trans de Reembolso de Autoservicio Comp +/-',
    'tt-drive-thru-trans-comp-pct': 'Trans de Autoservicio Comp %',
    'tt-dt-avg-check': 'DT Cheque Promedio',
    'tt-dt-avg-check-diff': 'DT Cheque Promedio +/-',
    'tt-dt-sales-diff-pct': 'DT Ventas +/- %',
    'tt-dt-tcs-diff-pct': "DT TC's +/- %",
    'tt-eat-in-avg-check-comp-pct': 'Cheque Promedio de Comer Aquí Comp %',
    'tt-eat-in-net-sales-comp-pct': 'Ventas Netas de Comer Aquí Comp %',
    'tt-eat-in-refund-sales-comp-pct': 'Ventas de Reembolso de Comer Aquí Comp %',
    'tt-eat-in-refund-trans-comp-diff': 'Trans de Reembolso de Comer Aquí Comp +/-',
    'tt-eat-in-trans-comp-diff': 'Trans de Comer Aquí Comp +/-',
    'tt-food-pct-actual-vs-budget': 'Alimentos % Actual Vs Presupuesto',
    'tt-food-actual-vs-budget': 'Alimentos Actual Vs Presupuesto',
    'tt-food-cost-diff': 'Costo de Alimentos +/-',
    'tt-food-var-diff': 'Varianza de Alimentos +/-',
    'tt-food-var-cost-diff': 'Costo de Varianza de Alimentos +/-',
    'tt-gap-variance-pct-diff': 'Varianza de Brecha % +/-',
    'tt-hourly-labor-pct-diff': 'Labor Por Hora % +/-',
    'tt-hourly-labor-diff-pct': 'Labor Por Hora +/- %',
    'tt-hourly-labor-hours-diff-pct': 'Horas de Labor Por Hora +/- %',
    'tt-kiosk-avg-check-comp-pct': 'Cheque Promedio de Kiosco Comp %',
    'tt-kiosk-net-sales-comp-pct': 'Ventas Netas de Kiosco Comp %',
    'tt-kiosk-refund-sales-comp-pct': 'Ventas de Reembolso de Kiosco Comp %',
    'tt-kiosk-refund-trans-comp-diff': 'Trans de Reembolso de Kiosco Comp +/-',
    'tt-kiosk-trans-comp-diff': 'Trans de Kiosco Comp +/-',
    'tt-lobby-avg-check': 'Lobby Cheque Promedio',
    'tt-lobby-avg-check-diff': 'Lobby Cheque Promedio +/-',
    'tt-lobby-sales-diff-pct': 'Lobby Ventas +/- %',
    'tt-lobby-tcs-diff-pct': "Lobby TC's +/- %",
    'tt-management-labor-diff': 'Labor Gerencial +/-',
    'tt-manager-void-amt-diff': 'Monto de Anulación de Gerente +/-',
    'tt-manager-void-cnt-comp': 'Cnt de Anulación de Gerente Comp',
    'tt-mgmt-labor-pct': 'Labor Gerencial %',
    'tt-mobile-delivery-avg-check-comp-pct': 'Cheque Promedio de Entrega Móvil Comp %',
    'tt-mobile-delivery-net-sales-comp-pct': 'Ventas Netas de Entrega Móvil Comp %',
    'tt-mobile-delivery-refund-sales-comp-pct': 'Ventas de Reembolso de Entrega Móvil Comp %',
    'tt-mobile-drive-thru-refund-trans-comp-diff': 'Trans de Reembolso de Autoservicio Móvil Comp +/-',
    'tt-mobile-drive-thru-trans-comp-diff': 'Trans de Autoservicio Móvil Comp +/-',
    'tt-mobile-take-out-avg-check-comp-pct': 'Cheque Promedio de Para Llevar Móvil Comp %',
    'tt-mobile-take-out-net-sales-comp-pct': 'Ventas Netas de Para Llevar Móvil Comp %',
    'tt-mobile-take-out-refund-sales-comp-pct': 'Ventas de Reembolso de Para Llevar Móvil Comp %',
    'tt-mobile-take-out-refund-trans-comp-diff': 'Trans de Reembolso de Para Llevar Móvil Comp +/-',
    'tt-mobile-take-out-trans-comp-diff': 'Trans de Para Llevar Móvil Comp +/-',
    'tt-net-sales-actual-vs-budget': 'Ventas Netas Actual Vs Presupuesto',
    'tt-net-sales-comp-pct': 'Ventas Netas Comp %',
    'tt-other-cost-diff': 'Costo de Otros +/-',
    'tt-other-var-diff': 'Varianza de Otros +/-',
    'tt-other-var-cost-diff': 'Costo de Varianza de Otros +/-',
    'tt-overring-amt-comp-diff': 'Monto de Sobreregistro Comp +/-',
    'tt-paper-cost-diff': 'Costo de Papel +/-',
    'tt-paper-var-diff': 'Varianza de Papel +/-',
    'tt-paper-var-cost-diff': 'Costo de Varianza de Papel +/-',
    'tt-proj-labor-guide-hours': 'Horas Guía de Labor Proyectadas',
    'tt-proj-labor-guide-hours-diff': 'Horas Guía de Labor Proyectadas +/-',
    'tt-refund-sales-comp-pct': 'Ventas de Reembolso Comp %',
    'tt-refund-trans': 'Trans de Reembolso',
    'tt-refund-trans-comp-diff': 'Trans de Reembolso Comp +/-',
    'tt-salaried-labor-diff-pct': 'Labor Asalariado +/- %',
    'tt-take-out-avg-check-comp-pct': 'Cheque Promedio de Para Llevar Comp %',
    'tt-take-out-net-sales-comp-pct': 'Ventas Netas de Para Llevar Comp %',
    'tt-take-out-refund-sales-comp-pct': 'Ventas de Reembolso de Para Llevar Comp %',
    'tt-take-out-refund-trans-comp-diff': 'Trans de Reembolso de Para Llevar Comp +/-',
    'tt-take-out-trans-comp-diff': 'Trans de Para Llevar Comp +/-',
    'tt-tc-diff-pct': 'TC +/- %',
    'tt-theoretical-food-cost-pct-diff': 'Costo Teórico de Alimentos % +/-',
    'tt-total-cost-diff': 'Costo Total +/-',
    'tt-total-labor-diff': 'Labor Total +/-',
    'tt-total-labor-pct-actual-vs-budget': 'Labor Total % Actual Vs Presupuesto',
    'tt-total-labor-actual-vs-budget': 'Labor Total Actual Vs Presupuesto',
    'tt-total-labor-cost': 'Costo de Labor Total',
    'tt-total-labor-cost-diff': 'Costo de Labor Total +/-',
    'tt-total-var-diff': 'Varianza Total +/-',
    'tt-total-var-cost-diff': 'Costo de Varianza Total +/-',
    'tt-total-waste-diff': 'Desperdicio Total +/-',
    'tt-total-waste-cost-diff': 'Costo de Desperdicio Total +/-',
    'tt-training-hours-diff': 'Horas de Capacitación +/-',
    'tt-transactions-comp-pct': 'Transacciones Comp %',
    'tt-trans-comp-pct': 'Trans Comp %',
    'tt-trans-per-labor-hour-diff': 'Trans / Hora de Labor +/-',
    // Shift Runner Scorecard info tooltip
    'tt-sms-shifts-explained':
      'cuenta segmentos del día trabajados como líder de piso (FL) programado, no turnos de entrada a salida. Un día hábil tiene {count} segmentos y un solo turno de trabajo puede abarcar varios, por lo que suele ser mayor que la cantidad de veces que la persona registró su entrada.',
    'tt-sms-overall-score': 'Puntuación General',
    'tt-sms-overall-score-explained':
      'se compone de un 50% de puntuación de finalización de formularios y un 50% de puntuación de métricas operativas.',
    'tt-sms-forms-completion-score': 'Puntuación de Finalización de Formularios',
    'tt-sms-forms-completion-score-explained':
      'se pondera igualmente entre las listas de verificación previas al turno y los caminos de viaje.',
    'tt-sms-operations-metrics-score': 'Puntuación de Métricas Operativas',
    'tt-sms-operations-metrics-score-explained':
      'se pondera igualmente en 4 métricas operativas:',
    'tt-sms-above-pct-is': 'Para todas las áreas, {pct}% o más es',
    'tt-sms-green': 'verde',
    'tt-sms-and-below-pct-is': 'y por debajo de {pct}% es',
    'tt-sms-red': 'rojo',
  },
  fr: {
    'tt-act-labor-guide-hours-diff': 'Heures guides MO réelles +/-',
    'tt-adj-proj-diff-hours-comp-pct': 'Heures proj ajust +/- comp %',
    'tt-adj-theoretical-food-cost-pct-diff': 'Coût matières théorique ajust % +/-',
    'tt-all-net-sales-diff-pct': 'Ventes nettes totales +/- %',
    'tt-all-net-sls': 'Ventes nettes tot.',
    'tt-avg-check-diff': 'Ticket moyen +/-',
    'tt-avg-hourly-rate-diff': 'Taux horaire moyen +/-',
    'tt-canceled-item-amt-comp': 'Mnt article annulé comp',
    'tt-canceled-item-cnt-comp-pct': 'Nb articles annulés comp %',
    'tt-canceled-order-amt-comp-pct': 'Mnt commande annulée comp %',
    'tt-canceled-order-cnt-comp-pct': 'Nb commandes annulées comp %',
    'tt-cogs': 'COGS',
    'tt-cogs-diff': 'COGS +/-',
    'tt-cogs-food': 'COGS matières',
    'tt-cogs-food-diff': 'COGS matières +/-',
    'tt-cogs-other': 'COGS autres',
    'tt-cogs-other-diff': 'COGS autres +/-',
    'tt-cogs-paper': 'COGS papier',
    'tt-cogs-paper-diff': 'COGS papier +/-',
    'tt-delivery-avg-check-comp-pct': 'Ticket moyen livraison comp %',
    'tt-delivery-net-sales-comp-pct': 'Ventes nettes livraison comp %',
    'tt-delivery-refund-sales-comp-pct': 'Ventes remboursées livraison comp %',
    'tt-delivery-refund-trans-comp-diff': 'Trans remboursées livraison comp +/-',
    'tt-delivery-trans-comp-diff': 'Trans livraison comp +/-',
    'tt-drive-thru-avg-check-comp-pct': 'Ticket moyen Drive comp %',
    'tt-drive-thru-net-sales-comp-pct': 'Ventes nettes Drive comp %',
    'tt-drive-thru-refund-sales-comp-pct': 'Ventes remboursées Drive comp %',
    'tt-drive-thru-refund-trans-comp-diff': 'Trans remboursées Drive comp +/-',
    'tt-drive-thru-trans-comp-pct': 'Trans Drive comp %',
    'tt-dt-avg-check': 'Ticket moyen DT',
    'tt-dt-avg-check-diff': 'Ticket moyen DT +/-',
    'tt-dt-sales-diff-pct': 'Ventes DT +/- %',
    'tt-dt-tcs-diff-pct': "TC DT +/- %",
    'tt-eat-in-avg-check-comp-pct': 'Ticket moyen sur place comp %',
    'tt-eat-in-net-sales-comp-pct': 'Ventes nettes sur place comp %',
    'tt-eat-in-refund-sales-comp-pct': 'Ventes remboursées sur place comp %',
    'tt-eat-in-refund-trans-comp-diff': 'Trans remboursées sur place comp +/-',
    'tt-eat-in-trans-comp-diff': 'Trans sur place comp +/-',
    'tt-food-pct-actual-vs-budget': 'Matières % réel vs budget',
    'tt-food-actual-vs-budget': 'Matières réel vs budget',
    'tt-food-cost-diff': 'Coût matières +/-',
    'tt-food-var-diff': 'Écart matières +/-',
    'tt-food-var-cost-diff': 'Coût écart matières +/-',
    'tt-gap-variance-pct-diff': 'Écart d’intervalle % +/-',
    'tt-hourly-labor-pct-diff': 'MO horaire % +/-',
    'tt-hourly-labor-diff-pct': 'MO horaire +/- %',
    'tt-hourly-labor-hours-diff-pct': 'Heures MO horaire +/- %',
    'tt-kiosk-avg-check-comp-pct': 'Ticket moyen borne comp %',
    'tt-kiosk-net-sales-comp-pct': 'Ventes nettes borne comp %',
    'tt-kiosk-refund-sales-comp-pct': 'Ventes remboursées borne comp %',
    'tt-kiosk-refund-trans-comp-diff': 'Trans remboursées borne comp +/-',
    'tt-kiosk-trans-comp-diff': 'Trans borne comp +/-',
    'tt-lobby-avg-check': 'Ticket moyen salle',
    'tt-lobby-avg-check-diff': 'Ticket moyen salle +/-',
    'tt-lobby-sales-diff-pct': 'Ventes salle +/- %',
    'tt-lobby-tcs-diff-pct': "TC salle +/- %",
    'tt-management-labor-diff': 'MO encadrement +/-',
    'tt-manager-void-amt-diff': 'Mnt annulations manager +/-',
    'tt-manager-void-cnt-comp': 'Nb annulations manager comp',
    'tt-mgmt-labor-pct': 'MO encadrement %',
    'tt-mobile-delivery-avg-check-comp-pct': 'Ticket moyen livraison mobile comp %',
    'tt-mobile-delivery-net-sales-comp-pct': 'Ventes nettes livraison mobile comp %',
    'tt-mobile-delivery-refund-sales-comp-pct': 'Ventes remboursées livraison mobile comp %',
    'tt-mobile-drive-thru-refund-trans-comp-diff': 'Trans remboursées Drive mobile comp +/-',
    'tt-mobile-drive-thru-trans-comp-diff': 'Trans Drive mobile comp +/-',
    'tt-mobile-take-out-avg-check-comp-pct': 'Ticket moyen à emporter mobile comp %',
    'tt-mobile-take-out-net-sales-comp-pct': 'Ventes nettes à emporter mobile comp %',
    'tt-mobile-take-out-refund-sales-comp-pct': 'Ventes remboursées à emporter mobile comp %',
    'tt-mobile-take-out-refund-trans-comp-diff': 'Trans remboursées à emporter mobile comp +/-',
    'tt-mobile-take-out-trans-comp-diff': 'Trans à emporter mobile comp +/-',
    'tt-net-sales-actual-vs-budget': 'Ventes nettes réel vs budget',
    'tt-net-sales-comp-pct': 'Ventes nettes comp %',
    'tt-other-cost-diff': 'Coût autres +/-',
    'tt-other-var-diff': 'Écart autres +/-',
    'tt-other-var-cost-diff': 'Coût écart autres +/-',
    'tt-overring-amt-comp-diff': 'Mnt surenregistrements comp +/-',
    'tt-paper-cost-diff': 'Coût papier +/-',
    'tt-paper-var-diff': 'Écart papier +/-',
    'tt-paper-var-cost-diff': 'Coût écart papier +/-',
    'tt-proj-labor-guide-hours': 'Heures guides MO prévues',
    'tt-proj-labor-guide-hours-diff': 'Heures guides MO prévues +/-',
    'tt-refund-sales-comp-pct': 'Ventes remboursées comp %',
    'tt-refund-trans': 'Trans remboursées',
    'tt-refund-trans-comp-diff': 'Trans remboursées comp +/-',
    'tt-salaried-labor-diff-pct': 'MO salariée +/- %',
    'tt-take-out-avg-check-comp-pct': 'Ticket moyen à emporter comp %',
    'tt-take-out-net-sales-comp-pct': 'Ventes nettes à emporter comp %',
    'tt-take-out-refund-sales-comp-pct': 'Ventes remboursées à emporter comp %',
    'tt-take-out-refund-trans-comp-diff': 'Trans remboursées à emporter comp +/-',
    'tt-take-out-trans-comp-diff': 'Trans à emporter comp +/-',
    'tt-tc-diff-pct': 'TC +/- %',
    'tt-theoretical-food-cost-pct-diff': 'Coût matières théorique % +/-',
    'tt-total-cost-diff': 'Coût total +/-',
    'tt-total-labor-diff': 'MO totale +/-',
    'tt-total-labor-pct-actual-vs-budget': 'MO totale % réel vs budget',
    'tt-total-labor-actual-vs-budget': 'MO totale réel vs budget',
    'tt-total-labor-cost': 'Coût MO totale',
    'tt-total-labor-cost-diff': 'Coût MO totale +/-',
    'tt-total-var-diff': 'Écart total +/-',
    'tt-total-var-cost-diff': 'Coût écart total +/-',
    'tt-total-waste-diff': 'Pertes totales +/-',
    'tt-total-waste-cost-diff': 'Coût pertes totales +/-',
    'tt-training-hours-diff': 'Heures de formation +/-',
    'tt-transactions-comp-pct': 'Transactions comp %',
    'tt-trans-comp-pct': 'Trans comp %',
    'tt-trans-per-labor-hour-diff': 'Trans / heure MO +/-',
    // Shift Runner Scorecard info tooltip
    'tt-sms-shifts-explained':
      'compte les périodes de la journée travaillées comme responsable de plancher (FL) planifié, et non les quarts de l’arrivée au départ. Un jour d’exploitation compte {count} périodes et un seul quart de travail peut en couvrir plusieurs, de sorte que ce nombre est habituellement plus élevé que le nombre de pointages.',
    'tt-sms-overall-score': 'Score global',
    'tt-sms-overall-score-explained':
      'est composé de 50 % du score d’achèvement des formulaires et de 50 % du score des métriques d’exploitation.',
    'tt-sms-forms-completion-score': 'Score d’achèvement des formulaires',
    'tt-sms-forms-completion-score-explained':
      'est pondéré à parts égales entre les listes de vérification avant quart et les parcours.',
    'tt-sms-operations-metrics-score': 'Score des métriques d’exploitation',
    'tt-sms-operations-metrics-score-explained':
      'est pondéré à parts égales sur 4 métriques d’exploitation :',
    'tt-sms-above-pct-is': 'Pour tous les secteurs, {pct} % ou plus est',
    'tt-sms-green': 'vert',
    'tt-sms-and-below-pct-is': 'et moins de {pct} % est',
    'tt-sms-red': 'rouge',
  },
  'fr-ca': {
    'tt-act-labor-guide-hours-diff': 'Heures guides main-d’œuvre réelles +/-',
    'tt-adj-proj-diff-hours-comp-pct': 'Heures prév ajust +/- comp %',
    'tt-adj-theoretical-food-cost-pct-diff': 'Coût théorique des aliments ajust % +/-',
    'tt-all-net-sales-diff-pct': 'Ventes nettes totales +/- %',
    'tt-all-net-sls': 'Ventes nettes tot.',
    'tt-avg-check-diff': 'Facture moyenne +/-',
    'tt-avg-hourly-rate-diff': 'Taux horaire moyen +/-',
    'tt-canceled-item-amt-comp': 'Mnt article annulé comp',
    'tt-canceled-item-cnt-comp-pct': 'Nb articles annulés comp %',
    'tt-canceled-order-amt-comp-pct': 'Mnt commande annulée comp %',
    'tt-canceled-order-cnt-comp-pct': 'Nb commandes annulées comp %',
    'tt-cogs': 'COGS',
    'tt-cogs-diff': 'COGS +/-',
    'tt-cogs-food': 'COGS aliments',
    'tt-cogs-food-diff': 'COGS aliments +/-',
    'tt-cogs-other': 'COGS autres',
    'tt-cogs-other-diff': 'COGS autres +/-',
    'tt-cogs-paper': 'COGS papier',
    'tt-cogs-paper-diff': 'COGS papier +/-',
    'tt-delivery-avg-check-comp-pct': 'Facture moyenne livraison comp %',
    'tt-delivery-net-sales-comp-pct': 'Ventes nettes livraison comp %',
    'tt-delivery-refund-sales-comp-pct': 'Ventes remboursées livraison comp %',
    'tt-delivery-refund-trans-comp-diff': 'Trans remboursées livraison comp +/-',
    'tt-delivery-trans-comp-diff': 'Trans livraison comp +/-',
    'tt-drive-thru-avg-check-comp-pct': 'Facture moyenne service au volant comp %',
    'tt-drive-thru-net-sales-comp-pct': 'Ventes nettes service au volant comp %',
    'tt-drive-thru-refund-sales-comp-pct': 'Ventes remboursées service au volant comp %',
    'tt-drive-thru-refund-trans-comp-diff': 'Trans remboursées service au volant comp +/-',
    'tt-drive-thru-trans-comp-pct': 'Trans service au volant comp %',
    'tt-dt-avg-check': 'Facture moyenne SV',
    'tt-dt-avg-check-diff': 'Facture moyenne SV +/-',
    'tt-dt-sales-diff-pct': 'Ventes SV +/- %',
    'tt-dt-tcs-diff-pct': "TC SV +/- %",
    'tt-eat-in-avg-check-comp-pct': 'Facture moyenne sur place comp %',
    'tt-eat-in-net-sales-comp-pct': 'Ventes nettes sur place comp %',
    'tt-eat-in-refund-sales-comp-pct': 'Ventes remboursées sur place comp %',
    'tt-eat-in-refund-trans-comp-diff': 'Trans remboursées sur place comp +/-',
    'tt-eat-in-trans-comp-diff': 'Trans sur place comp +/-',
    'tt-food-pct-actual-vs-budget': 'Aliments % réel c. budget',
    'tt-food-actual-vs-budget': 'Aliments réel c. budget',
    'tt-food-cost-diff': 'Coût des aliments +/-',
    'tt-food-var-diff': 'Écart aliments +/-',
    'tt-food-var-cost-diff': 'Coût de l’écart aliments +/-',
    'tt-gap-variance-pct-diff': 'Écart d’intervalle % +/-',
    'tt-hourly-labor-pct-diff': 'Main-d’œuvre horaire % +/-',
    'tt-hourly-labor-diff-pct': 'Main-d’œuvre horaire +/- %',
    'tt-hourly-labor-hours-diff-pct': 'Heures de main-d’œuvre horaire +/- %',
    'tt-kiosk-avg-check-comp-pct': 'Facture moyenne borne comp %',
    'tt-kiosk-net-sales-comp-pct': 'Ventes nettes borne comp %',
    'tt-kiosk-refund-sales-comp-pct': 'Ventes remboursées borne comp %',
    'tt-kiosk-refund-trans-comp-diff': 'Trans remboursées borne comp +/-',
    'tt-kiosk-trans-comp-diff': 'Trans borne comp +/-',
    'tt-lobby-avg-check': 'Facture moyenne salle à manger',
    'tt-lobby-avg-check-diff': 'Facture moyenne salle à manger +/-',
    'tt-lobby-sales-diff-pct': 'Ventes salle à manger +/- %',
    'tt-lobby-tcs-diff-pct': "TC salle à manger +/- %",
    'tt-management-labor-diff': 'Main-d’œuvre gestion +/-',
    'tt-manager-void-amt-diff': 'Mnt annulations gérant +/-',
    'tt-manager-void-cnt-comp': 'Nb annulations gérant comp',
    'tt-mgmt-labor-pct': 'Main-d’œuvre gestion %',
    'tt-mobile-delivery-avg-check-comp-pct': 'Facture moyenne livraison mobile comp %',
    'tt-mobile-delivery-net-sales-comp-pct': 'Ventes nettes livraison mobile comp %',
    'tt-mobile-delivery-refund-sales-comp-pct': 'Ventes remboursées livraison mobile comp %',
    'tt-mobile-drive-thru-refund-trans-comp-diff': 'Trans remboursées service au volant mobile comp +/-',
    'tt-mobile-drive-thru-trans-comp-diff': 'Trans service au volant mobile comp +/-',
    'tt-mobile-take-out-avg-check-comp-pct': 'Facture moyenne pour emporter mobile comp %',
    'tt-mobile-take-out-net-sales-comp-pct': 'Ventes nettes pour emporter mobile comp %',
    'tt-mobile-take-out-refund-sales-comp-pct': 'Ventes remboursées pour emporter mobile comp %',
    'tt-mobile-take-out-refund-trans-comp-diff': 'Trans remboursées pour emporter mobile comp +/-',
    'tt-mobile-take-out-trans-comp-diff': 'Trans pour emporter mobile comp +/-',
    'tt-net-sales-actual-vs-budget': 'Ventes nettes réel c. budget',
    'tt-net-sales-comp-pct': 'Ventes nettes comp %',
    'tt-other-cost-diff': 'Coût autres +/-',
    'tt-other-var-diff': 'Écart autres +/-',
    'tt-other-var-cost-diff': 'Coût de l’écart autres +/-',
    'tt-overring-amt-comp-diff': 'Mnt surenregistrements comp +/-',
    'tt-paper-cost-diff': 'Coût du papier +/-',
    'tt-paper-var-diff': 'Écart papier +/-',
    'tt-paper-var-cost-diff': 'Coût de l’écart papier +/-',
    'tt-proj-labor-guide-hours': 'Heures guides main-d’œuvre prévues',
    'tt-proj-labor-guide-hours-diff': 'Heures guides main-d’œuvre prévues +/-',
    'tt-refund-sales-comp-pct': 'Ventes remboursées comp %',
    'tt-refund-trans': 'Trans remboursées',
    'tt-refund-trans-comp-diff': 'Trans remboursées comp +/-',
    'tt-salaried-labor-diff-pct': 'Main-d’œuvre salariée +/- %',
    'tt-take-out-avg-check-comp-pct': 'Facture moyenne pour emporter comp %',
    'tt-take-out-net-sales-comp-pct': 'Ventes nettes pour emporter comp %',
    'tt-take-out-refund-sales-comp-pct': 'Ventes remboursées pour emporter comp %',
    'tt-take-out-refund-trans-comp-diff': 'Trans remboursées pour emporter comp +/-',
    'tt-take-out-trans-comp-diff': 'Trans pour emporter comp +/-',
    'tt-tc-diff-pct': 'TC +/- %',
    'tt-theoretical-food-cost-pct-diff': 'Coût théorique des aliments % +/-',
    'tt-total-cost-diff': 'Coût total +/-',
    'tt-total-labor-diff': 'Main-d’œuvre totale +/-',
    'tt-total-labor-pct-actual-vs-budget': 'Main-d’œuvre totale % réel c. budget',
    'tt-total-labor-actual-vs-budget': 'Main-d’œuvre totale réel c. budget',
    'tt-total-labor-cost': 'Coût total de la main-d’œuvre',
    'tt-total-labor-cost-diff': 'Coût total de la main-d’œuvre +/-',
    'tt-total-var-diff': 'Écart total +/-',
    'tt-total-var-cost-diff': 'Coût de l’écart total +/-',
    'tt-total-waste-diff': 'Pertes totales +/-',
    'tt-total-waste-cost-diff': 'Coût des pertes totales +/-',
    'tt-training-hours-diff': 'Heures de formation +/-',
    'tt-transactions-comp-pct': 'Transactions comp %',
    'tt-trans-comp-pct': 'Trans comp %',
    'tt-trans-per-labor-hour-diff': 'Trans / heure de main-d’œuvre +/-',
    // Shift Runner Scorecard info tooltip
    'tt-sms-shifts-explained':
      'compte les périodes de la journée travaillées comme responsable de plancher (FL) planifié, et non les quarts de l’arrivée au départ. Un jour d’exploitation compte {count} périodes et un seul quart de travail peut en couvrir plusieurs, de sorte que ce nombre est habituellement plus élevé que le nombre de poinçons.',
    'tt-sms-overall-score': 'Score global',
    'tt-sms-overall-score-explained':
      'est composé de 50 % du score d’achèvement des formulaires et de 50 % du score des métriques d’exploitation.',
    'tt-sms-forms-completion-score': 'Score d’achèvement des formulaires',
    'tt-sms-forms-completion-score-explained':
      'est pondéré à parts égales entre les listes de vérification avant quart et les parcours.',
    'tt-sms-operations-metrics-score': 'Score des métriques d’exploitation',
    'tt-sms-operations-metrics-score-explained':
      'est pondéré à parts égales sur 4 métriques d’exploitation :',
    'tt-sms-above-pct-is': 'Pour tous les secteurs, {pct} % ou plus est',
    'tt-sms-green': 'vert',
    'tt-sms-and-below-pct-is': 'et moins de {pct} % est',
    'tt-sms-red': 'rouge',
  },
};
